import { OFFER_REQUEST_ERRORS } from 'cpool-constants';
import { z } from 'zod';

import type { EventSchema } from '../../../../../utils/EventSchema';
import { _Event } from '../../../../_Event';

export class LoanRequest_EuropaceOffersSyncResponseErrorReceived extends _Event {
    getSchema() {
        return z.object({
            error: z.any(),
            reasons: z.array(
                z.enum([
                    OFFER_REQUEST_ERRORS.GENERAL.UNKNOWN_ERROR,
                    ...Object.values(OFFER_REQUEST_ERRORS.EUROPACE.SYNC_OFFERS),
                    ...Object.values(OFFER_REQUEST_ERRORS.EUROPACE.READ_APPLICATIONS),
                    ...Object.values(OFFER_REQUEST_ERRORS.EUROPACE.GRAPHQL),
                ]),
            ),
        });
    }

    static example(): EventSchema<LoanRequest_EuropaceOffersSyncResponseErrorReceived> {
        return {
            error: 'Error happened',
            reasons: [OFFER_REQUEST_ERRORS.EUROPACE.SYNC_OFFERS.NOT_IMPORTED_ERROR],
        };
    }
}
